/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordChangeForm
 */
export interface PasswordChangeForm {
    /**
     * 
     * @type {string}
     * @memberof PasswordChangeForm
     */
    oldPassword: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordChangeForm
     */
    newPassword: string;
}

/**
 * Check if a given object implements the PasswordChangeForm interface.
 */
export function instanceOfPasswordChangeForm(value: object): value is PasswordChangeForm {
    if (!('oldPassword' in value) || value['oldPassword'] === undefined) return false;
    if (!('newPassword' in value) || value['newPassword'] === undefined) return false;
    return true;
}

export function PasswordChangeFormFromJSON(json: any): PasswordChangeForm {
    return PasswordChangeFormFromJSONTyped(json, false);
}

export function PasswordChangeFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordChangeForm {
    if (json == null) {
        return json;
    }
    return {
        
        'oldPassword': json['oldPassword'],
        'newPassword': json['newPassword'],
    };
}

export function PasswordChangeFormToJSON(value?: PasswordChangeForm | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'oldPassword': value['oldPassword'],
        'newPassword': value['newPassword'],
    };
}

